import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import BasePlayerEmbed from "./BasePlayerEmbed";

var QQPlayerEmbed = function QQPlayerEmbed(_ref) {
  var videoId = _ref.videoId,
      extra = _objectWithoutProperties(_ref, ["videoId"]);

  var frameUrl = "https://v.qq.com/iframe/player.html?vid=".concat(videoId, "&tiny=1&auto=1");
  return /*#__PURE__*/React.createElement(BasePlayerEmbed, _extends({
    src: frameUrl
  }, extra));
};

export default QQPlayerEmbed;